export const patterns = {
  numbers: '[0-9.]*',
  time: '[0-9:]*',
  any: '[sS]*',
  integers: '[0-9]*',
};
